exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inTotal[data-v-0885fc25]{margin:0;line-height:32px;margin-right:14px}\n", ""]);

// exports
